import BrandMark from "../components/brand/BrandMark";
import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../components/ui/card";
import { toast } from "sonner";
import { ArrowLeft, Mail, CheckCircle } from "lucide-react";

const API = '/api';

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
      toast.success("Si el correo existe, recibirás un enlace");
    } catch (error) {
      toast.error("Error al procesar solicitud");
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center p-4">
        <div className="w-full max-w-md">
          <Link to="/" className="flex items-center justify-center gap-2 mb-8">
            <BrandMark size="md" asLink={false} />
          </Link>

          <Card className="border-slate-100 shadow-lg">
            <CardContent className="p-8 text-center">
              <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <CheckCircle className="w-8 h-8 text-emerald-600" />
              </div>
              <h2 className="text-xl font-semibold text-slate-900 mb-2" style={{ fontFamily: 'Manrope, sans-serif' }}>
                Revisa tu correo
              </h2>
              <p className="text-slate-600 mb-6">
                Si existe una cuenta con <strong>{email}</strong>, recibirás un enlace para restablecer tu contraseña.
              </p>
              <p className="text-sm text-slate-500 mb-6">
                El enlace expira en 30 minutos y sólo puede usarse una vez.
              </p>
              <Link to="/login">
                <Button variant="outline" className="w-full" data-testid="back-to-login-btn">
                  <ArrowLeft className="w-4 h-4 mr-2" />
                  Volver a Iniciar Sesión
                </Button>
              </Link>
            </CardContent>
          </Card>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center justify-center gap-2 mb-8">
          <BrandMark size="md" asLink={false} />
        </Link>

        <Card className="border-slate-100 shadow-lg">
          <CardHeader className="text-center pb-4">
            <CardTitle className="text-2xl font-semibold text-slate-900" style={{ fontFamily: 'Manrope, sans-serif' }}>
              Recuperar Contraseña
            </CardTitle>
            <CardDescription className="text-slate-600">
              Ingresa tu correo y te enviaremos un enlace
            </CardDescription>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="email" className="text-slate-700">Correo electrónico</Label>
                <Input
                  id="email"
                  type="email"
                  placeholder="tu@email.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="h-12 bg-slate-50 border-slate-200 focus:ring-2 focus:ring-slate-900"
                  data-testid="forgot-email-input"
                />
              </div>

              <Button
                type="submit"
                className="w-full h-12 rounded-full bg-slate-900 hover:bg-slate-800 text-white font-semibold"
                disabled={loading}
                data-testid="forgot-submit-btn"
              >
                {loading ? (
                  "Enviando..."
                ) : (
                  <>
                    <Mail className="w-4 h-4 mr-2" />
                    Enviar Enlace
                  </>
                )}
              </Button>
            </form>

            <div className="mt-6 text-center">
              <Link to="/login" className="text-slate-600 hover:text-slate-800 text-sm" data-testid="back-to-login-link">
                <ArrowLeft className="w-4 h-4 inline mr-1" />
                Volver a Iniciar Sesión
              </Link>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default ForgotPassword;
